import { useaxios } from "../../../utils/useaxios";
export default (text) => recaller => setrecaller => item_suggestion => setitem_suggestion => settext => clear => {
    var today = new Date();
    today = today.getFullYear() + '-' + (today.getMonth() + 1) + '-' + today.getDate();
    useaxios('item/getitem_recommend.php', { text }).then((res) => {
        if (res == "Unauthorized") {
            clear();
            return;
        } else if (res == "request_failed") {
            alert('no internet connection');
            return false;
        } else if (res.status == "ok") {
            setitem_suggestion(res.data);
        }
    });
}